import {
	type DismissalData,
	GraphQlMutationResult,
	type MutationResult,
	MutationSuccessResultCreator,
	type UndoDismissalData,
} from '../../graphql-result';

/**
 * This class is responsible for creating a mutation result for a successful dismissal response.
 */
export class DismissalSuccessResultCreator<
	T extends DismissalData = DismissalData,
> extends MutationSuccessResultCreator<T> {
	constructor(
		protected response: Response,
		protected dismissalData: T,
	) {
		super(response, dismissalData);
	}

	makeMutationResult(): MutationResult<DismissalData> {
		return new GraphQlMutationResult<DismissalData>(
			this.response.status,
			this.response.statusText,
			{
				data: this.dismissalData,
			},
		);
	}
}

export class UndoDismissalSuccessResultCreator<
	T extends UndoDismissalData = UndoDismissalData,
> extends MutationSuccessResultCreator<T> {
	constructor(
		protected response: Response,
		protected undoDismissalData: T,
	) {
		super(response, undoDismissalData);
	}

	makeMutationResult(): MutationResult<UndoDismissalData> {
		return new GraphQlMutationResult<UndoDismissalData>(
			this.response.status,
			this.response.statusText,
			{
				data: this.undoDismissalData,
			},
		);
	}
}
